var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1440",
      "width": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "작품 목록",
      "showsFilterButton": ""
    },
    scopedSlots: _vm._u([{
      key: "add-button",
      fn: function fn() {
        return [_c('work-classifications-view', {
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var attrs = _ref.attrs,
                  on = _ref.on;
              return [_c('v-tooltip', {
                attrs: {
                  "left": "",
                  "transition": "fade-transition"
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function fn(tooltipProps) {
                    return [_c('span', _vm._g(_vm._b({}, 'span', tooltipProps.attrs, false), tooltipProps.on), [_c('v-btn', _vm._g(_vm._b({
                      attrs: {
                        "icon": "",
                        "text": ""
                      }
                    }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-cog")])], 1)], 1)];
                  }
                }], null, true)
              }, [_vm._v(" 작품상세정보 기본값 설정 ")])];
            }
          }])
        })];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function fn() {
        return [_c('work-list-mode-auction')];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showsSearch,
      callback: function callback($$v) {
        _vm.showsSearch = $$v;
      },
      expression: "showsSearch"
    }
  }), _c('list-search-default', _vm._b({}, 'list-search-default', {
    showsSearch: _vm.showsSearch,
    loading: _vm.loading,
    searchKeys: _vm.searchKeys
  }, false)), _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    attrs: {
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref2) {
          var value = _ref2.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: "header.category",
      fn: function fn(_ref3) {
        var header = _ref3.header;
        return [_c('v-layout', {
          attrs: {
            "align-center": ""
          }
        }, [_c('span', [_vm._v(" " + _vm._s(header.text) + " ")]), _c('auction-category-view', _vm._b({
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref4) {
              var attrs = _ref4.attrs,
                  on = _ref4.on;
              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "my-n1",
                attrs: {
                  "x-small": "",
                  "text": "",
                  "icon": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-cog")])], 1)];
            }
          }], null, true)
        }, 'auction-category-view', {
          group: _vm.group
        }, false))], 1)];
      }
    }, {
      key: "item.isSoldOut",
      fn: function fn(_ref5) {
        var value = _ref5.value,
            item = _ref5.item;
        return [_c('v-switch', {
          staticClass: "pa-0 ma-0",
          attrs: {
            "inset": "",
            "dense": "",
            "hide-details": ""
          },
          on: {
            "click": function click($event) {
              return _vm.save({
                _id: item._id,
                isSoldOut: !value
              });
            }
          },
          model: {
            value: item.isSoldOut,
            callback: function callback($$v) {
              _vm.$set(item, "isSoldOut", $$v);
            },
            expression: "item.isSoldOut"
          }
        }, [_c('span', {
          staticClass: "subtitle-2",
          attrs: {
            "slot": "label"
          },
          slot: "label"
        }, [_vm._v(" " + _vm._s(value ? "판매완료" : "판매중") + " ")])])];
      }
    }, {
      key: "item.imgs",
      fn: function fn(_ref6) {
        var value = _ref6.value;
        return _c('v-row', {
          attrs: {
            "align": "center",
            "no-gutters": ""
          }
        }, [_c('v-col', {
          staticClass: "py-4 pr-2",
          attrs: {
            "cols": "auto"
          }
        }, [_c('work-imgs-overlay', {
          attrs: {
            "imgs": value
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var _value$;

              var attrs = _ref7.attrs,
                  on = _ref7.on;
              return [_c('v-img', _vm._g(_vm._b({
                staticStyle: {
                  "cursor": "pointer"
                },
                attrs: {
                  "width": "48",
                  "height": "48",
                  "src": value === null || value === void 0 ? void 0 : (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.url
                }
              }, 'v-img', attrs, false), on))];
            }
          }], null, true)
        })], 1), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm._v(_vm._s((value === null || value === void 0 ? void 0 : value.length) || 0 > 1 ? "X ".concat(value.length) : ""))])], 1);
      }
    }, {
      key: "item._bids",
      fn: function fn(_ref8) {
        var value = _ref8.value,
            item = _ref8.item;
        return [_c('work-bids-list', {
          attrs: {
            "work": item
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref9) {
              var attrs = _ref9.attrs,
                  on = _ref9.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "block": "",
                  "height": "100%",
                  "tile": "",
                  "color": "secondary"
                }
              }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(value === null || value === void 0 ? void 0 : value.length) + "건 ")])];
            }
          }], null, true)
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_vm.isProgram ? _c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "color": "secondary",
            "disabled": !item.isAuctionEnded
          },
          on: {
            "click": function click($event) {
              return _vm.email(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-email")])], 1) : _vm._e(), _c('work-view', {
          attrs: {
            "value": item
          },
          on: {
            "input": _vm.update
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref11) {
              var attrs = _ref11.attrs,
                  on = _ref11.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "text": "",
                  "icon": "",
                  "color": "primary"
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-pencil")])], 1)];
            }
          }], null, true)
        }), _c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "color": "red"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)];
      }
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items,
    itemsPerPage: -1
  }, false)), _c('v-pagination', {
    staticClass: "my-4",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  }), _c('work-view', {
    on: {
      "input": _vm.update
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref12) {
        var attrs = _ref12.attrs,
            on = _ref12.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "fab": "",
            "fixed": "",
            "right": "",
            "bottom": "",
            "color": "primary",
            "large": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-pencil")])], 1)];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }